export class PoItemVariantDto{
    uom:string;
    unitPrice:string;
    size:string;
    qunatity:string;
    amount:string;
}